// extracted by mini-css-extract-plugin
export default {"conceptLink":"ChatMarkdownText_conceptLink__gdjgb","noValidLink":"ChatMarkdownText_noValidLink__88ytT","chatMarkdown":"ChatMarkdownText_chatMarkdown__0RLNq"};